import { Hero } from '../Components/Hero'
import { PorQueElegirnos } from '../Components/PorQueElegirnos';
import PropuestaValor from '../Components/PropuestaValor';
import Asesoramiento from '../Components/Asesoramiento';
import useSEOConfig from '../../../hooks/seo/useSEOConfig'
import { Navbar } from "../Components/Navbar";
import decorativo from '../../../Assets/img/shape13.svg'
import Formulario from '../Components/Formulario';
import { useConfig } from '../../../context/ConfigContext';
import { useLocation } from 'react-router-dom'
import { buscarTextoSeo } from '../../../utils/buscarTextoSeo'

export const Caucion = () => {

    const { origen: parametros, config } = useConfig()
    const location = useLocation();
    const textoSeo = buscarTextoSeo(location.pathname, config.pais);
    useSEOConfig(
        {
            title: textoSeo?.title ?? "Seguros para Empresas & Pymes - Protegé tu inversión ante todo riesgo",
            description: textoSeo?.description ?? "Conocé la amplia variedad de seguros que tenemos para vos · Auto · Accidentes Personales · Moto · Hogar · Asistencia al viajero · Mala Praxis · Vida · Celular",
            tituloCompleto: !!textoSeo,
            keywords: "Seguros de Auto, Seguro para moto, Seguros económicos, Cotizar seguro de auto, Seguro Mala praxis, Seguro online, Asistencia al viajero, Aseguradoras, Seguros rivadavia, Seguro flota, Cotizar seguro",
            ogTitle:
                config.pais === "UY" ?
                    "Segurarse - Corredor de Seguros digital"
                    : "Segurarse - Bróker Integral de Seguros digitales",
            ogDescription: "Contratá el seguro que necesitás en pocos pasos. Seguros personales a tu medida al mejor precio. Te asesoramos en todo momento ¡Invertí en tu tranquilidad!",
            twitterCard: "summary_large_image",
        }
    )

    return (
        <>
            <Navbar
                rubro="auto"
            />
            <div style={{ backgroundColor: "white" }}>
                <Hero
                    titulo='Seguro de Caución'
                    subTitulo={{ __html: "Protegé tu patrimonio ante eventuales incumplimientos de pago.<br/><br/>¿Empezamos?" }}
                    url={
                        (parametros!.origen === "SEGURARSE" && config.pais === "AR") ?
                            '/cotizador-de-seguros-pymes-caucion'
                            : '#formulario'}
                    icon='#icon-seg-caucion'
                    color={parametros!.origen !== "SEGURARSE" ? parametros!.bgColor : undefined}
                />
                <div className={`pt-70 pt-lg-80 pb-40 position-relative ${parametros!.origen === "SEGURARSE" && "bg-primary"}`}
                    style={parametros!.origen !== "SEGURARSE" ? { backgroundColor: parametros!.bgColor } : {}}>
                    <img
                        className="d-none d-lg-block pos16 blend-multipy"
                        src={decorativo}
                        alt="Decorative Shape"
                    />
                    <div className="container">
                        <h2 className="ff-mukta fw-bold fs-30 fs-lg-40 text-white text-center mb-16 mb-lg-25">
                            ¿Qué cubre?
                        </h2>
                        <div className="col-10 col-lg-12 mx-auto">
                            <p className="fs-17 fs-lg-20 lh-13 text-white text-center mb-16 mb-lg-20">
                                Garantiza el cumplimiento de las obligaciones contractuales de una persona o entidad asegurada hacia un tercero. Este seguro tiene como objetivo garantizar el cumplimiento de obligaciones financieras o legales.<br />
                                La aseguradora se obliga a abonar al asegurado y/o beneficiario una suma determinada en virtud de los perjuicios que le haya ocasionado el tomador del seguro como consecuencia de su incumplimiento.
                                <br /><br />
                            </p>
                            <div className="px-20 px-lg-0 maxw-lg-920p mx-auto">
                                <div className="row gx-lg-80">
                                    <div className="col">
                                        <p className="fs-17 fs-lg-20 lh-13 text-white text-center mb-16 mb-lg-20">Los principales actores son:</p>
                                        <ul className="list-unstyled list-bullet-md fs-16 lh-14 mb-0 text-white">
                                            <li className="bullet-check-primary ps-35 ps-lg-45 border-bottom border-2 border-white border-opacity-25">
                                                <b>Tomador:</b> Es quién solicita el seguro y debe cumplir con las obligaciones garantizadas.
                                            </li>
                                            <li className="bullet-check-primary ps-35 ps-lg-45 border-bottom border-2 border-white border-opacity-25">
                                                <b>Asegurado:</b> Es el tercero a favor de quien se emite la póliza.
                                            </li>
                                            <li className="bullet-check-primary ps-35 ps-lg-45 border-2 border-white border-opacity-25">
                                                <b>Asegurador:</b> Es el encargado de emitir la póliza.
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <p className="fs-17 fs-lg-20 lh-13 text-white text-center mb-16 mb-lg-20 mt-4">
                                Dentro de las principales coberturas, se incluyen:
                            </p>
                        </div>
                        <div className="px-20 px-lg-0 maxw-lg-920p mx-auto">
                            <div className="row gx-lg-80">
                                <div className="col">
                                    <ul className="list-unstyled list-bullet-md fs-16 lh-14 mb-0 text-white">
                                        <li className="bullet-check-primary ps-35 ps-lg-45 border-bottom border-2 border-white border-opacity-25">
                                            <b>Cumplimiento de contratos:</b> si una persona o entidad tiene un contrato con un tercero y no cumple con sus obligaciones contractuales, el seguro de caución puede cubrir las pérdidas sufridas por el tercero debido a dicho incumplimiento.
                                        </li>
                                        <li className="bullet-check-primary ps-35 ps-lg-45 border-bottom border-2 border-white border-opacity-25">
                                            <b>Licencias y permisos:</b> en ciertos sectores y actividades, las autoridades pueden requerir una garantía de cumplimiento antes de otorgar una licencia o permiso. El seguro de caución puede proporcionar esta garantía en lugar de tener que proporcionar un depósito o garantía en efectivo.
                                        </li>
                                        <li className="bullet-check-primary ps-35 ps-lg-45 border-bottom border-2 border-white border-opacity-25">
                                            <b>Aduanas y comercio internacional:</b> las autoridades aduaneras pueden requerir una garantía de cumplimiento de las obligaciones fiscales y aduaneras.
                                        </li>
                                        <li className="bullet-check-primary ps-35 ps-lg-45 border-bottom border-2 border-white border-opacity-25 border-lg-none">
                                            <b>Reclamaciones judiciales:</b> en determinados casos legales, las autoridades pueden requerir una garantía para cubrir posibles indemnizaciones en caso de que el fallo sea desfavorable para la parte asegurada.
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {(parametros!.origen !== "SEGURARSE" || config.pais === "UY") &&
                    <Formulario
                        rubro='Caucion'
                        titulo='Cotizá seguro de Caución'
                        origen={config.pais === "UY" ? "UY-SEGURARSE" : parametros!.origen}
                        color={parametros!.bgColor}
                        extras={parametros!.riesgoData.find(riesgo => riesgo.id === "caucion")?.formulario || []}
                    />
                }
                <PorQueElegirnos color={parametros!.bgColor} />
                <PropuestaValor
                    origen={parametros!.origen}
                    color={parametros!.bgColor}
                />
                {/* {parametros!.origen === "SEGURARSE" &&
                    <Asesoramiento />
                } */}
            </div>
        </>
    )
}